import { Box, Typography } from "@mui/material";
import Header from "../../components/global/Header";
import EuroRoundedIcon from "@mui/icons-material/EuroRounded";
import CurrencyPoundRoundedIcon from "@mui/icons-material/CurrencyPoundRounded";
import AttachMoneyRoundedIcon from "@mui/icons-material/AttachMoneyRounded";
import StatBox from "../../components/subscriberComponents/StatBox";
import {
  chartBoxSubscriber,
  chartBoxQuery,
  chartBoxRevenue,
  CurrencyPairData,
} from "../../data/DashBoardData";
import PermContactCalendarRoundedIcon from "@mui/icons-material/PermContactCalendarRounded";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";

const Dashboard = () => {
  const [object, setObject] = useState({});
  const [subscribe, setSubscribe] = useState("");
  const [subInfo, setSubInfo] = useState({});

  useEffect(() => {
    const isSubscriber = secureLocalStorage.getItem("Subscription");
    if (isSubscriber) {
      setSubscribe(isSubscriber);
    }
  }, []);

  useEffect(() => {
    const subInfo = JSON.parse(secureLocalStorage.getItem("SubInfo"));
    const userInfo = JSON.parse(secureLocalStorage.getItem("userInfo"));

    if (subInfo) {
      setSubInfo(subInfo);
    }
    if (userInfo) {
      setObject(userInfo);
    }
  }, []);

  return (
    <>
      {subscribe == true ? (
        <Box m="2vw">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Header title="DASHBOARD" subTitle="Welcome to your dashboard" />
          </Box>
          <Box
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows="140px"
            gap="20px"
          >
            <Box
              gridColumn="span 4"
              border="1px solid var(--color-white-50)"
              backgroundColor={"#201939"}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <StatBox
                currencyPair={CurrencyPairData[0].currencypair}
                amount={CurrencyPairData[0].value}
                icon={
                  <EuroRoundedIcon
                    sx={{
                      fontSize: "26px",
                      color: "teal",
                    }}
                  />
                }
                chartData={chartBoxRevenue.chartData}
                dataKey={chartBoxRevenue.dataKey}
                Color={chartBoxRevenue.color}
              />
            </Box>
            <Box
              gridColumn="span 4"
              backgroundColor={"#201939"}
              border="1px solid var(--color-white-50)"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <StatBox
                currencyPair={CurrencyPairData[1].currencypair}
                amount={CurrencyPairData[1].value}
                icon={
                  <CurrencyPoundRoundedIcon
                    sx={{ fontSize: "26px", color: "#FF8042" }}
                  />
                }
                chartData={chartBoxSubscriber.chartData}
                dataKey={chartBoxSubscriber.dataKey}
                Color={chartBoxSubscriber.color}
              />
            </Box>
            <Box
              gridColumn="span 4"
              backgroundColor={"#201939"}
              display="flex"
              border="1px solid var(--color-white-50)"
              alignItems="center"
              justifyContent="center"
            >
              <StatBox
                currencyPair={CurrencyPairData[2].currencypair}
                amount={CurrencyPairData[2].value}
                icon={
                  <AttachMoneyRoundedIcon
                    sx={{ fontSize: "26px", color: "gold" }}
                  />
                }
                chartData={chartBoxQuery.chartData}
                dataKey={chartBoxQuery.dataKey}
                Color={chartBoxQuery.color}
              />
            </Box>
            <Box
              gridColumn="span 12"
              gridRow="span 1"
              backgroundColor={"#201939"}
              border="1px solid var(--color-white-50)"
              overflow="auto"
              p="20px"
            >
              <Typography
                variant="h5"
                fontWeight="bold"
                color="var(--white)"
                sx={{ display: "flex", alignItems: "center" }}
              >
                <PermContactCalendarRoundedIcon
                  sx={{ marginRight: "0.5rem" }}
                />
                User Information
              </Typography>
              <Grid container spacing={3} padding="1.3vw 0.5vw 0 0.5vw">
                {object !== null && (
                  <>
                    <Grid item xs={4}>
                      <Box>
                        <Typography
                          variant="body1"
                          sx={{ color: "var(--white)" }}
                        >
                          <span className="m--font-boldest">Name: </span>
                          <span style={{ color: "var(--color-white-50)" }}>
                            {object.username}
                          </span>
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item xs={4}>
                      <Box>
                        <Typography
                          variant="body1"
                          sx={{ color: "var(--white)" }}
                        >
                          <span className="m--font-boldest">Username: </span>
                          <span style={{ color: "var(--color-white-50)" }}>
                            {object.username}
                          </span>
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box>
                        <Typography
                          variant="body1"
                          sx={{ color: "var(--white)" }}
                        >
                          <span className="m--font-boldest">Email: </span>
                          <span style={{ color: "var(--color-white-50)" }}>
                            {object.email}
                          </span>
                        </Typography>
                      </Box>
                    </Grid>
                  </>
                )}
              </Grid>

              <Box mt="20px"></Box>
            </Box>

            <Box
              gridColumn="span 12"
              gridRow="span 1"
              backgroundColor={"#201939"}
              border="1px solid var(--color-white-50)"
              overflow="auto"
              p="20px"
            >
              <Typography
                variant="h5"
                fontWeight="bold"
                color="var(--white)"
                sx={{ display: "flex", alignItems: "center" }}
              >
                <PermContactCalendarRoundedIcon
                  sx={{ marginRight: "0.5rem" }}
                />
                Subscription Information
              </Typography>
              <Grid container spacing={3} padding="1.3vw 0.5vw 0 0.5vw">
                {subInfo !== null && (
                  <>
                    <Grid item xs={4}>
                      <Box>
                        <Typography
                          variant="body1"
                          sx={{ color: "var(--white)" }}
                        >
                          <span className="m--font-boldest">Plan: </span>
                          <span style={{ color: "var(--color-white-50)" }}>
                            {subInfo.plan}
                          </span>
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item xs={4}>
                      <Box>
                        <Typography
                          variant="body1"
                          sx={{ color: "var(--white)" }}
                        >
                          <span className="m--font-boldest">
                            Account Type:{" "}
                          </span>
                          <span style={{ color: "var(--color-white-50)" }}>
                            {subInfo.account_type}
                          </span>
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item xs={4}>
                      <Box>
                        <Typography
                          variant="body1"
                          sx={{ color: "var(--white)" }}
                        >
                          <span className="m--font-boldest">
                            Date and Time:{" "}
                          </span>
                          <span style={{ color: "var(--color-white-50)" }}>
                            {subInfo.date}
                          </span>
                        </Typography>
                      </Box>
                    </Grid>
                  </>
                )}
              </Grid>

              <Box mt="20px"></Box>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box m="2vw">
          <Header subTitle="No Access" />
        </Box>
      )}
    </>
  );
};

export default Dashboard;
